export default "__VITE_ASSET__5ac9f9fa__"